import React, { FC, useEffect } from 'react';
import cx from 'clsx';

import { MenuItemCard } from 'routes/Menu/MenuItemCard';
import { useMenu } from 'components/MenuContext/MenuContext';
import { Shimmer } from 'routes/Menu/MenuCategories/Shimmer';

import styles from './styles.module.scss';
import { MENU_CATEGORIES_TEST_IDS } from 'routes/Menu/MenuCategories/const';
import { MenuSection } from 'components/MenuSection/MenuSection';
import { useOrderHistory } from 'hooks/context/OrderHistory';
import { trackMenu } from 'util/Analytics';

const MenuCategories: FC = () => {
  const { menu, loading } = useMenu();
  const { orders } = useOrderHistory();

  useEffect(() => {
    if (menu?.items) trackMenu(menu?.items);
  }, [menu?.items]);

  if (loading) return <Shimmer showItemImage={false} />;

  const categories = (menu?.categories || []);

  if (categories.length < 1) return null;

  // hide category name if only category available
  const hideCategoryName = categories.length === 1 && orders.length === 0;

  return (
    <>
      <div className={cx({ [styles.menu]: menu })}>
        {categories.map(({ name, id, items }) => (
          <MenuSection
            id={id}
            key={id}
            title={hideCategoryName ? undefined : name}
            titleTestId={MENU_CATEGORIES_TEST_IDS.categoryName}
          >
            {items.map(item => (
              <MenuItemCard key={item.id} item={item} />
            ))}
          </MenuSection>
        ))}
      </div>
    </>
  );
};

export { MenuCategories };
